import { apiClient } from "../../../../lib/api-client";
import { useQuery } from '@tanstack/react-query';
import { MyAccountSettings } from "../types/MyAccountSettings";
import { useAuth } from "../../../../contexts/auth";

export const useGetMyAccountSettings = () => {
    const { user } = useAuth();

    const { data, isLoading } = useQuery({
        queryKey: ['my-account-settings', user?.userName],
        queryFn: async () => await apiClient.get('my-account/settings') as MyAccountSettings,
        staleTime: 5 * 60 * 1000
    });

    return {
        data: data || undefined,
        isLoading: isLoading
    };
};
